<template>
  <div v-show="!gameStarted">
    <div class="screen-root login-overlay">
      <img
        src="../../assets/img/login/background.jpg"
        class="screen-root-image"
        alt=""
      />
      <div v-show="!showAbout" class="login-box">
        <!-- <button @click="maxWindow">make fullscreen</button> -->
        <img class="logo" src="../../assets/logo.png" alt="" />
        <br />
        <div class="header-box">
          <span class="hdr">{{ $t('homePageTexts.enter') }}</span>
        </div>
        <div class="box">
          <div class="flex box space-between">
            <div class="input-box">
              <div class="text-size">{{ $t('homePageTexts.enterPass') }}</div>
              <div class="center-obj">
                <span v-show="showError" class="error-txt">
                  {{ $t('homePageTexts.wrongPass') }}
                </span>
              </div>
              <!-- Select login type -->
              <!-- Image Map Generated by http://www.image-map.net/ -->
              <div class="login_gray_btn" v-show="!showLoginBtn">
                <img
                  :src="require(`../../assets/img/btns/ok_disable.png`)"
                  style="cursor:pointer;"
                  @click="login_map_pop()"
                  v-on:click="loginCounter += 1"
                />
              </div>
              <div v-show="showLoginBtn">
                <img
                  :src="require(`../../assets/img/login/login-bg.png`)"
                  usemap="#image-map"
                />
                <map name="image-map">
                  <area
                    target=""
                    alt="Yellow"
                    title="Yellow"
                    href="#"
                    coords="89,5,29,26"
                    shape="rect"
                    @click="CheckGameCode('yellow')"
                  />
                  <area
                    target=""
                    alt="Orange"
                    title="Orange"
                    href="#"
                    coords="29,50,88,29"
                    shape="rect"
                    @click="CheckGameCode('orange')"
                  />
                  <area
                    target=""
                    alt="Green"
                    title="Green"
                    href="#"
                    coords="29,54,88,77"
                    shape="rect"
                    @click="CheckGameCode('green')"
                  />
                  <area
                    target=""
                    alt="Blue"
                    title="Blue"
                    href="#"
                    coords="28,80,88,100"
                    shape="rect"
                    @click="CheckGameCode('blue')"
                  />
                  <area
                    target=""
                    alt="Black"
                    title="Black"
                    href="#"
                    coords="88,123,29,103"
                    shape="rect"
                    @click="CheckGameCode('black')"
                  />
                </map>
              </div>
            </div>
            <div class="text-size">
              <span class="or-text">{{ $t('homePageTexts.or') }}</span>
              <div class="line-vert"></div>
            </div>
            <div class="belt-box" v-if="isCamera">
              <div class="language-box">
                <div
                  style="idth: 100%; position: absolute;margin: 0 0 0 -20px;"
                >
                  <img
                    :src="require(`../../assets/img/lang-flags/down-arrow.png`)"
                    style="width: 20px;height: 20px;  cursor: pointer;"
                    @click="isLangFlagOpen()"
                    v-on:click="langCounter += 1"
                  />
                </div>
                <table v-show="!showLangList" class="selectedLangClass">
                  <tr v-if="isLanguageSet == 'en'">
                    <td>English</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/eng-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                  <tr v-if="isLanguageSet == 'he'">
                    <td>עברית</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/israel-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                  <tr v-if="isLanguageSet == 'ar' || isLanguageSet == ''">
                    <td>عربى</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/arabic-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                </table>

                <table v-show="showLangList" class="langList">
                  <tr @click="translatorFun('en')">
                    <td>English</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/eng-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                  <tr @click="translatorFun('he')">
                    <td>עברית</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/israel-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                  <tr @click="translatorFun('ar')">
                    <td>عربى</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/arabic-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                </table>
              </div>
              <div class="text-size">{{ $t('homePageTexts.newGame') }}</div>
              <br />
              <router-link to="/animation-generator/introduction">
                <div
                  class="nav-link"
                  @click="(gameStarted = true), maxWindow()"
                  id="button"
                >
                  <div>
                    <img
                      class="belt"
                      :src="require(`../../assets/img/btns/${playPic}.png`)"
                      @mouseenter="playPic = 'play_hover'"
                      @mouseleave="playPic = 'play'"
                      alt=""
                    />
                  </div>
                </div>
              </router-link>
              <a href="/manual.pdf" target="_blank" rel="noopener noreferrer">
                <div class="dowlnoad-link" v-html="$t('homePageTexts.download_pdf_link')"></div>
              </a>
            </div>

            <div class="belt-box" v-else>
              <div class="language-box">
                <div
                  style="idth: 100%; position: absolute;margin: 0 0 0 -20px;"
                >
                  <img
                    :src="require(`../../assets/img/lang-flags/down-arrow.png`)"
                    style="width: 20px;height: 20px;  cursor: pointer;"
                    @click="isLangFlagOpen()"
                    v-on:click="langCounter += 1"
                  />
                </div>
                <table v-show="!showLangList" class="selectedLangClass">
                  <tr v-if="isLanguageSet == 'en'">
                    <td>English</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/eng-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                  <tr v-if="isLanguageSet == 'he' || isLanguageSet == ''">
                    <td>עברית</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/israel-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                  <tr v-if="isLanguageSet == 'ar'">
                    <td>عربى</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/arabic-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                </table>

                <table v-show="showLangList" class="langList">
                  <tr @click="translatorFun('en')">
                    <td>English</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/eng-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                  <tr @click="translatorFun('he')">
                    <td>עברית</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/israel-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                  <tr @click="translatorFun('ar')">
                    <td>عربى</td>
                    <td>
                      <img
                        :src="
                          require(`../../assets/img/lang-flags/arabic-lang-flag.png`)
                        "
                        style="width: 34px;height: 30px;"
                      />
                    </td>
                  </tr>
                </table>
              </div>
              <div class="text-size">{{ $t('homePageTexts.newGame') }}</div>
              <br />
              <div class="nav-link" @click="showNoCameraError()" id="button">
                <div>
                  <img
                    class="belt"
                    :src="require(`../../assets/img/btns/${playPic}.png`)"
                    @mouseenter="playPic = 'play_hover'"
                    @mouseleave="playPic = 'play'"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!showAbout" class="footer-div flex space-around">
        <div class="pointer mail-link" @click="showAbout = !showAbout">
          {{ $t('homePageTexts.about') }}
        </div>
        <div>•</div>
        <div class="contact flex">
          <!-- <div @click="showContactUs = !showContactUs"> -->
          <div>
            <span class=""
              ><a class="mail-link" href="mailto:Nikudu.edu@gmail.com">{{
                $t('homePageTexts.contactUs')
              }}</a></span
            >
          </div>
        </div>
        <div>•</div>
        <div class="rtl">
          <span class="">כל הזכויות שמורות </span>
          <span>למיכל פרוייליך בהר.</span>
          <span> פותח במסגרת </span>
          <a
            class="footer-link mail-link"
            href="https://edstart.education.gov.il/"
            target="_blank"
          >
            <span> EdStart</span></a
          >
          <span> ©</span>
        </div>
      </div>
      <!-- about modal -->
      <div v-show="showAbout" class="login-box ">
        <div class="hdr about">{{ $t('homePageTexts.about') }}</div>
        <div class="back-btn">
          <img
            @click="
              showAbout = false;
              showContactUs = false;
            "
            class="back-img pointer"
            src="../../assets/img/login/back-09.png"
            alt=""
          />
        </div>
        <div class="about-p ::-webkit-scrollbar">
          <p
            class="text-size"
            style="direction:rtl"
            v-html="$t('homePageTexts.aboutTxt')"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import belts from '../../config/constants';
export default {
  name: 'Welcome',
  data() {
    return {
      belts,
      showAbout: false,
      showLangList: false,
      showLoginBtn: false,
      loginCounter: 1,
      langCounter: 1,
      isLanguageSet:
        localStorage.getItem('selectedLang') &&
        localStorage.getItem('selectedLang').length > 0
          ? localStorage.getItem('selectedLang')
          : 'he',
      lvlCode: '',
      gameStarted: false,
      levelCodes: belts.beltsCodes,
      showError: false,
      okPic: 'ok',
      playPic: 'play',
      isCamera: null
    };
  },
  mounted() {
    this.$store.commit('resetUnlockedBelts');
    this.handleIsCamera();
    //console.log("page loading ---", (localStorage.getItem('selectedLang') && localStorage.getItem('selectedLang').length>0)?localStorage.getItem('selectedLang'):'raj');
  },
  methods: {
    handleIsCamera() {
      try {
        navigator.mediaDevices
          .getUserMedia({ video: { facingMode: 'user' } })
          .then(() => {
            this.isCamera = true;
          })
          .catch(err => this.handleCameraErr(err));
      } catch (err) {
        this.handleCameraErr(err);
      }
    },
    handleCameraErr(err) {
      console.warn(err);
      this.isCamera = false;
    },
    handleOkHover(event) {
      event.target.src = '../../assets/img/btns/ok.png';
    },
    handleOkunhover(event) {
      event.target.src = '../../assets/img/btns/ok.png';
    },
    CheckGameCode(type = '') {
      if (!this.isCamera) {
        this.showNoCameraError();
        return;
      }
      // If type not blank the call
      if (type != '') {
        this.lvlCode = type;
      }
      if (this.lvlCode) {
        this.levelCodes;
        if (this.levelCodes[this.lvlCode]) {
          this.$store.dispatch('setBeltCodeLogic', this.lvlCode);
          this.maxWindow();
          this.gameStarted = true;
          this.$router.push('/belts-selection');
        } else {
          this.showError = true;
        }
      } else {
        this.showError = true;
      }
    },
    maxWindow() {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
    },
    translatorFun(lang = '') {
      localStorage.setItem('selectedLang', lang);
      localStorage.getItem('selectedLang') &&
      localStorage.getItem('selectedLang').length > 0
        ? localStorage.getItem('selectedLang')
        : localStorage.setItem('selectedLang', 'he');
      this.$router.go(this.$router.currentRoute);
    },
    isLangFlagOpen() {
      if (this.langCounter == 1) {
        this.showLangList = true;
      } else {
        this.showLangList = false;
        this.langCounter = 0;
      }
    },
    login_map_pop() {
      if (this.loginCounter == 1) {
        this.showLoginBtn = true;
      } else {
        this.showLoginBtn = false;
        this.loginCounter = 0;
      }
    },
    showNoCameraError() {
      alert('אין אפשרות להתחיל משחק ללא הרשאת שימוש במצלמה.');
    }
  },
  watch: {
    lvlCode() {
      if (this.lvlCode === '') {
        this.showError = false;
      }
    }
  },
  computed: {
    isButtonInactive() {
      if (this.lvlCode.length >= 4 && this.lvlCode != '') {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';

.dowlnoad-link {
  font-size: 11px;
}

.screen-root-image {
  position: fixed;
  right: $posX;
  left: $posX;
  top: $posY;
  bottom: $posY;
  width: 1000px;
  height: 562.5px;
  color: black;
}
.center-obj {
  margin-right: auto;
  margin-left: auto;
  position: relative;
}
.pass-input {
  padding-top: 5%;
  // background-color: $color-cream;
  background-color: transparent;
  direction: rtl;
  color: black;
  border-bottom: 1px solid black;
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
  width: 80%;
}
.or-text {
  position: relative;
  top: 1vw;
}
.confirm-btn {
  margin-top: 10%;
  border-radius: 30px;
  background-color: #ea0001;
  width: 70px;
  height: 35px;
  margin-right: auto;
  margin-left: auto;
  color: #efe6e1;
  line-height: 35px;
  font-size: 14px;
  cursor: pointer;
}
.line-vert {
  border-left: 1px solid black;
  height: 10em;
  position: relative;
  top: 3vh;
  left: 1vh;
  bottom: 1vh;
}

.login-overlay {
  position: fixed;
  top: $posY;
  right: $posX;
  left: $posX;
  bottom: $posY;
}
.login-box {
  background-image: url('../../assets/img/login/bgpaper-07.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;
  top: 10%;
  height: 80%;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
.logo {
  position: relative;
  height: 20%;
  top: 10%;
  margin-bottom: 5%;
  margin-left: auto;
  margin-right: auto;
}
.header-box {
  margin-bottom: 2%;
}
.hdr {
  font-family: $font-main;
  font-size: 24px;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
}
.belt {
  margin-left: auto;
  margin-right: auto;
  height: 70%;
  width: 70%;
}
.footer-div {
  max-width: 44%;
  color: black;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  bottom: 0;
  font-size: 10px;
}
.back-btn {
  direction: rtl;
  position: relative;
  right: 70px;
  z-index: 500;
  top: -30px;
  font-family: $font-main;
}
.back-img {
  height: 10px;
  font-family: $font-main;
}
.text-size {
  position: relative;
  font-size: 14px;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  top: 0;
  font-family: $font-main;
}

.nav-link {
  text-decoration: underline;
  font-family: $font-main;
}

.mail-link {
  color: #000;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

.about-p {
  // background-color: pink;
  margin-left: auto;
  margin-right: auto;
  height: 300px;
  width: 80%;
  font-size: 14px;
  overflow-x: scroll;
  padding-right: 3%;
  font-family: $font-main;
}
.bold-about-title {
  font-size: 10pt;
}
.about {
  padding-top: 10%;
  font-family: $font-main;
}
.inactive {
  background-color: #cccccc;
  cursor: not-allowed;
}
.error-txt {
  color: #ea0001;
  position: relative;
  font-size: 10px;
  top: 10px;
  right: 20px;
  font-family: $font-main;
  z-index: 200;
}
.login_gray_btn {
  padding: 20px 0px 10px 20px;
}
.box {
  align-items: center;
  justify-content: center;
  font-size: 0.8vw;
  max-width: 88%;
  margin-left: auto;
  margin-right: auto;
  font-family: $font-main;
}
.belt-box {
  width: 20vw;
  height: 5vw;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  font-family: $font-main;
}
.input-box {
  width: 20vw;
  height: 5vw;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  font-family: $font-main;
}
.rtl {
  direction: rtl;
}
.language-box {
  position: relative;
  top: -164px;
  left: 100px;
  height: 0;
}
.input-box img {
  cursor: pointer;
  background: #ccc;
  margin: 0 0 0 40px;
}
.language-box tr {
  cursor: pointer;
}
</style>
